



import Component from 'vue-class-component';
import {Mixins, Prop} from 'vue-property-decorator';
import InputMixin from '@/components/input/InputMixin';

@Component({
  mixins: [InputMixin]
})
export default class BooleanCheckboxInput extends Mixins<InputMixin>(InputMixin) {
  @Prop({default: true}) private readonly trueValue: any;
  @Prop({default: false}) private readonly falseValue: any;
  @Prop({default: null}) private readonly optionLabel: any;

  get inputValue() {
    return this.value === this.trueValue;
  }

  get label() {
    return this.optionLabel;
  }

  public onInputChange(data: any) {
    if (this.isReadOnly) {
      return;
    }

    const value = data === true ? this.trueValue : this.falseValue;
    this.commitValue(value);
  }

  public commitValue(value: any) {
    this.$emit('input', value);

    if (this.changeDetectable) {
      this.$store.commit('commitValue', {
        itemId: this.getId,
        value,
        originValue: this.originValue
      });
    }
  }
}
